import React from 'react';
import ContactSection from '../components/Sections/Contact';

const Contact: React.FC = () => {
  return <ContactSection />;
};

export default Contact; 